<template>
	<v-container>
		<v-row>
			<v-col
					v-if="$vuetify.breakpoint.mdAndUp"
					lg="4"
					md="4"
					xl="4"
			>
				<div class="py-4">
					<current-user-short-block />
				</div>
			</v-col>
			<v-col
					class="px-sm-only-0 px-xs-0"
					lg="8"
					md="8"
					xl="8"
			>
				<router-view class="mt-4" />
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import CurrentUserShortBlock from "@/components/CurrentUserShortBlock.vue";
import { mapGetters } from "vuex";

export default {
  components: { CurrentUserShortBlock },
  computed: {
    ...mapGetters({
      currentUser: "getCurrentUser",
    }),
  },
};
</script>
